import type { ReactNode } from 'react';
import { Box, useTheme } from '@mui/material';
import { historyLabelTextColor } from './historyLabelColor';

export function HistoryLines({
  title,
  action,
  color = null,
}: {
  title: string | string[];
  action: ReactNode;
  color?: string | null | Array<string | null>;
}) {
  const theme = useTheme();
  const titles = Array.isArray(title) ? title : [title];
  const swatches = Array.isArray(color) ? color : [color];

  return (
    <>
      <Box component="span" sx={{ display: 'block' }}>
        {action}
      </Box>
      <Box
        component="span"
        sx={{ display: 'block', fontWeight: 400, color: 'text.secondary' }}
      >
        {titles.map((label, index) => (
          <Box component="span" key={`${label}-${index}`}>
            {index === 0 ? null : index === titles.length - 1 ? ' and ' : ', '}
            <Box
              component="span"
              sx={{
                color:
                  historyLabelTextColor(theme, swatches[index]) ?? 'inherit',
              }}
            >
              {label}
            </Box>
          </Box>
        ))}
      </Box>
    </>
  );
}
